




















import Vue from "vue";
import {api} from "@/ts/constants";

export default Vue.extend({
    name: "Settings",
    data: () => ({
        apiUrlChanged: false,
        rotating: false,
        updateServerToken: -1,
        tokenChangeSaved: false,
    }),
    methods: {
        reload() {
            this.rotating = true;
            location.reload();
        },
    },
    computed: {
        reloadNeeded() {
            return this.apiUrlChanged;
        },
        apiUrl: {
            get(): string {
                return api;
            },
            set(v: string) {
                localStorage.api = v;
                this.apiUrlChanged = v !== api;
            },
        },
        mapboxKey: {
            get(): string {
                return this.$store.state.mapboxKey;
            },
            set(v: string) {
                this.tokenChangeSaved = false;
                clearTimeout(this.updateServerToken);
                this.updateServerToken = setTimeout(async () => {
                    console.warn("UPDATING SERVER TOKEN");
                    await this.$store.dispatch('apiRequest', {url: 'photos/setMapboxToken', body: {token: v}});
                    this.$store.commit('mapboxKey', v);
                    this.tokenChangeSaved = true;
                }, 500);
            },
        },
    }
});
